import { faClock } from '@fortawesome/pro-regular-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '@feathr/components';

import * as styles from './MilestoneTimer.css';

interface IMilestoneTimerProps {
  time: number;
}

function MilestoneTimer({ time }: IMilestoneTimerProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <Icon icon={faClock} />
      <span>{t('{{time}} min remaining', { time })}</span>
    </div>
  );
}

export default MilestoneTimer;
